import { render } from "./ScOperationsV2.vue?vue&type=template&id=e783a4e0"
import script from "./ScOperationsV2.vue?vue&type=script&lang=js"
export * from "./ScOperationsV2.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__